import React from "react";
import { Container, Flex, Box, Badge, Link } from "theme-ui";
import ContentContainer from "@solid-ui-components/ContentContainer";
import Reveal from "@solid-ui-components/Reveal";
import Divider from "@solid-ui-components/Divider";
import ContentText from "@solid-ui-components/ContentText";
import ContentImages from "@solid-ui-components/ContentImages";
import WithDefaultContent from "@solid-ui-blocks/WithDefaultContent";

import { FaRegClock } from "react-icons/fa";

const styles = {
  wrapper: {
    flex: [`100%`, null, null, 1],
    minWidth: 300,
    maxWidth: [`none`, null, null, 500],
    cursor: `pointer`,
    p: 3,
  },
  card: {
    overflow: `hidden`,
    height: `full`,
  },
  content: {
    alignItems: `stretch`,
    flexDirection: [`row`, null, null, `column`],
    height: `full`,
  },
  body: {
    display: `flex`,
    flexDirection: `column`,
    justifyContent: `center`,
    flex: 1,
    p: 4,
  },
  footerWrapper: {
    alignItems: `center`,
  },
  postInfo: {
    flex: 1,
    flexWrap: `wrap`,
    justifyContent: `space-between`,
    color: `omega`,
    ml: 0,
  },
  imageWrapper: {
    textAlign: `center`,
    position: `relative`,
    display: `block`,
    height: `full`,
  },
  image: {
    display: [`none`, `block`],
    height: `full`,
    bg: `omegaLighter`,
    borderRadius: `default`,
    minHeight: `15rem`,
    div: {
      p: `0 !important`,
    },
  },
  avatar: {
    size: 42,
    bg: `omegaLighter`,
    borderRadius: `full`,
    borderStyle: `solid`,
    borderWidth: `md`,
    borderColor: `omegaLighter`,
    boxSizing: `content-box`,
    img: {
      objectPosition: "top center !important",
    },
  },
};

const BlogBlock01 = ({ content: { text, collection, buttons } }) => {
  return (
    <Container>
      <Box sx={{ textAlign: `center` }}>
        <ContentText content={text} />
      </Box>
      <Divider />
      {collection && (
        <Reveal>
          <Flex sx={{ flexWrap: `wrap`, justifyContent: `center`, m: -3 }}>
            {collection.map(
              (
                {
                  container,
                  text,
                  images,
                  avatar,
                  buttons,
                  link,
                  authorLink,
                  categoryLink,
                },
                index
              ) => (
                <Box key={`item-${index}`} sx={styles.wrapper} href={link}>
                  <ContentContainer
                    content={container}
                    variant="cards.interactive"
                    sx={styles.card}
                  >
                    <Flex as="article" sx={styles.content}>
                      {/* Image */}
                      <Box
                        sx={{ flex: [0, 1], m: 2, mb: [null, null, null, 0] }}
                        style={{
                          maxHeight: "290px",
                          borderRadius: "8px",
                        }}
                      >
                        <Box sx={styles.imageWrapper}>
                          <ContentImages
                            content={{ images }}
                            sx={styles.image}
                            imageEffect="fadeIn"
                          />
                        </Box>
                      </Box>
                      <Box sx={styles.body}>
                        {/* Category */}
                        {text?.[0]?.text && (
                          <Link color={text?.[0]?.color} href={categoryLink}>
                            <Box sx={{ display: `inline-block` }}>
                              <Box mb="3">
                                <Badge
                                  variant="tag"
                                  sx={{ bg: `alphaLighter` }}
                                  color={text[0]?.color}
                                >
                                  {text[0].text}
                                </Badge>
                              </Box>
                            </Box>
                          </Link>
                        )}
                        {/* Title */}
                        <ContentText
                          content={text?.[1]}
                          sx={{ flex: [0, 0, `auto`] }}
                        />
                        {/* Excerpt */}
                        <ContentText
                          content={text?.[2]}
                          variant="small"
                          sx={{
                            flex: `auto`,
                            mb: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal", // Allow wrapping for multiple lines
                            display: "-webkit-box", // Use WebKit-based box layout for multi-line ellipsis
                            WebkitBoxOrient: "vertical", // Set box orientation to vertical
                            WebkitLineClamp: 3,
                          }}
                        />
                      </Box>
                    </Flex>
                  </ContentContainer>
                </Box>
              )
            )}
          </Flex>
        </Reveal>
      )}
    </Container>
  );
};

export default WithDefaultContent(BlogBlock01);
